<div class="file-upload-container step-wrapper">
  <div class="upload-header">
    <h1 class="upload-title">{{ title }}</h1>
    <h3 class="upload-subtitle" *ngIf="subTitle">{{ subTitle }}</h3>
  </div>

  <ng-container *ngTemplateOutlet="buttons || defaultButtons"> </ng-container>
  <ng-template #defaultButtons>
    <ul class="upload-buttons">
      <input type="file" #fileDropRef id="fileDropRef" (change)="handleFileUpload($event)" class="d-none" />
      <li>
        <button class="btn w-lg h-lg secondary" (click)="fileDropRef.click()">
          {{ 'global.upload_from_my_device' | translate }}
        </button>
      </li>
    </ul>
  </ng-template>
</div>
